import { styled } from '@mui/material';

export const LiveSearchBoxWrapper = styled('div')`
  width: 100%;
`;